module.exports = __webpack_public_path__ + "static/media/6833.2776a8cb.jpg";